import React, { createContext, useContext,useState, useEffect } from 'react'

// 创建屏幕宽度上下文
const ScreenWidthContext = createContext()


// 2. 创建Provider组件
export const ScreenWidthProvider = ({ children }) => {


  const [screenWidth, setScreenWidth] = useState(() => {
    // 安全获取初始宽度（兼容SSR场景）
    return typeof window !== 'undefined' ? window.innerWidth : 0
  })
  const [showDesktopUI, setShowDesktopUI] = useState(false)


  useEffect(() => {
    let timeoutId = null
    
    // 带防抖的resize处理器
    const handleResize = () => {
      setShowDesktopUI(window.innerWidth > 800)

      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        const newWidth = window.innerWidth
        // 只有宽度变化超过5px才更新（减少重渲染）
        if (Math.abs(newWidth - screenWidth) > 5) {
            setScreenWidth(newWidth)
        }
      }, 150) // 防抖时间150ms
    }

    // 添加事件监听
    window.addEventListener('resize', handleResize)
    
    // 立即获取初始值
    handleResize()

    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize)
      clearTimeout(timeoutId)
    }
  }, []) // 空依赖数组确保只注册一次


  return (
    <ScreenWidthContext.Provider value={{ screenWidth, showDesktopUI }}>
      {children}
    </ScreenWidthContext.Provider>
  )
}

// 3. 创建自定义Hook
export const ScreenWidthPort = () => {
  const context = useContext(ScreenWidthContext)
  if (!context) {
    throw new Error('useViewport必须在ViewportProvider内使用')
  }
  return context
}